import React from 'react';

type StatusVariant = 'blue' | 'amber' | 'green' | 'red' | 'gray';

interface StatusBadgeProps {
  label: string;
  variant?: StatusVariant;
}

const variantClasses: Record<StatusVariant, string> = {
  blue: 'bg-blue-100 text-blue-700',
  amber: 'bg-amber-100 text-amber-700',
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  gray: 'bg-gray-100 text-gray-700',
};

export function getStatusVariant(status: string): StatusVariant {
  switch (status) {
    case 'Requested':
      return 'blue';
    case 'InReview':
    case 'Processing':
      return 'amber';
    case 'Complete':
    case 'Consented':
      return 'green';
    case 'Reject':
      return 'red';
    case 'Canceled':
    default:
      return 'gray';
  }
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ label, variant = 'gray' }) => {
  return (
    <span
      className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${variantClasses[variant]}`}
    >
      {label}
    </span>
  );
};
